import React, { useEffect, useState } from 'react'
import { FaUserEdit } from 'react-icons/fa'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Card from '../../../SharedComponents/Card'
import Spinner from '../../../SharedComponents/Spinner'
import axios from 'axios'
import config from '../../../../config.json';
import { NotificationManager } from 'react-notifications';
import { parseDateFromAPI } from '../../../../helpers/validators';

export default function CardioExamsList() {
    const [loading, setLoading] = useState(false)
    const { id } = useParams();
    const [cardioExams, setCardioExams] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getCardioExams();
    }, [])

    const getCardioExams = () => {
        setLoading(true);
        axios({
            method: 'get',
            url: `${config.SERVER_URL}/patients/${id}/exams/cardio`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token')
            },
        })
            .then(res => {
                if (typeof (res.data) === "string") {
                    // NotificationManager.info(res.data)
                } else {
                    setCardioExams(res.data);
                }

            })
            .catch(err => {
                if (err.response.status === 401) {
                    navigate('/signin')
                }
                NotificationManager.error(err.response.data)
            })
            .finally(() => setLoading(false));
    }


    return (
        <>
            {loading ? <Spinner /> : null}
            <Card title={'Кардиолошки прегледи'}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Датум на преглед</th>
                            <th scope="col">Доктор</th>
                            <th scope="col" style={{ width: '165px', paddingTop: '0' }}>
                                <Link to='cardio/add' type="button" className="btn align-self-end" style={{ backgroundColor: "#39828f", color: "#fff" }}>Креирај преглед</Link>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cardioExams.map((exam, index) => {
                            const examDate = parseDateFromAPI(exam.exam_date);
                            return (
                                <tr key={exam.id}>
                                    <th>{index + 1}</th>
                                    <td>{`${examDate.getDate()}/${examDate.getMonth() + 1 < 10 ? '0' + (examDate.getMonth() + 1) : (examDate.getMonth() + 1)}/${examDate.getFullYear()}`}</td>
                                    <td>{exam.name_cyrilic ? exam.name_cyrilic : exam.name_latin}</td>

                                    <td style={{ width: '50px', paddingTop: '0' }}>
                                        <Link to={`cardio/${exam.id}`} type="button" className="btn">
                                            <FaUserEdit style={{ color: '#39828f' }} />
                                        </Link>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </Card>
        </>
    )
}
